import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { MESSAGE, rolePermissions } from '../constants/Permission';
import { IFullState } from '../types/All.type';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const AuditCom = React.lazy(() => import('../components/Audits'));
const Unauthorized = React.lazy(
  () => import('../components/Auth/UnAuthorized')
);

export const AuditContainer = styled.div`
  padding: 5px;
`;

function Requests(): ReactElement {
  const { permissions } = useSelector(
    (state: IFullState) => state.genesisUserRolePermission
  );

  return (
    <SuspenseLoadPage>
      {permissions.includes(rolePermissions.listAudit) ? (
        <AuditContainer>
          <AuditCom />
        </AuditContainer>
      ) : (
        <Unauthorized message={MESSAGE.unAuthorized} backOption={false} />
      )}
    </SuspenseLoadPage>
  );
}

export default Requests;
